import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { UserSettings } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { ScoreService } from '../scores/scores.service';




@Component({
  selector: 'ladder-level',
  templateUrl: './ladderlevel.component.html',
  styleUrls: ['./ladderlevel.component.scss']
})
export class ChangeLadderLevelComponent implements OnInit {
  public busy: boolean;
  public userSettings: UserSettings[] = [];

  constructor(private router: Router, private userSvc: UserService) {

  }

  ngOnInit(): void {
    this.userSvc.getLaddersAndLevels().subscribe(
      (resp) => {
        this.userSettings = resp;
      }
    );
  }

  public setLadderLevel(evt: any, ladderId: string, levelId: number) {
    evt.preventDefault();
    this.userSvc.clearCache();
    localStorage.setItem('ladderId', ladderId);
    localStorage.setItem('levelId', `${levelId}`);
    this.router.navigate(['/home']);
  }
}
